import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

// import * as html2pdf from 'html2pdf.js'
// import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { addDays, addMonths, differenceInDays, differenceInMonths } from 'date-fns';

@Injectable({
    providedIn: 'root',
})
export class UtilitiesService {



    constructor() { }



    public cloneObject(obj, deep = true) {
        let that = this;

        var result = {};
        for (let key in obj) {
            if (obj[key] instanceof Date) {
                result[key] = new Date(obj[key].getTime());
            } else if (deep && obj[key] instanceof Object) {
                if (obj[key] instanceof Array) {
                    result[key] = [];

                    obj[key].forEach(function (item) {
                        if (item instanceof Date) {
                            result[key].push(new Date(item.getTime()));
                        } else if (item instanceof Object) {
                            result[key].push(that.cloneObject(item, true));
                        } else {
                            result[key].push(item);
                        }
                    });
                } else {
                    result[key] = that.cloneObject(obj[key], deep);
                }
            } else {
                result[key] = obj[key];
            }
        }
        return result;
    }



    public DeepGet(obj, properties) {
        // USAGE - console.log(this.UtilitiesService.DeepGet({ abc: { def: 123 } }, ['abc', 'def']));

        // If we have reached an undefined/null property
        // then stop executing and return undefined.
        if (obj === undefined || obj === null)
            return;

        // If the path array has no more elements, we've reached
        // the intended property and return its value.
        if (properties.length === 0)
            return obj;

        // Prepare our found property and path array for recursion
        var foundSoFar = obj[properties[0]];
        var remainingProperties = properties.slice(1);

        return this.DeepGet(foundSoFar, remainingProperties);
    }



    /**
    * Deep merge two objects.
    * @param target
    * @param ...sources
    */
    public DeepMerge(target, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();

        if (this.IsObject(target) && this.IsObject(source)) {
            for (const key in source) {
                if (this.IsObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    this.DeepMerge(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }

        return this.DeepMerge(target, ...sources);
    }



    /**
     * Retrieve a fixed number of elements from an array, evenly distributed but
     * always including the first and last elements.
     *
     * @param   {Array} items - The array to operate on.
     * @param   {number} n - The number of elements to extract.
     * @returns {Array}
     */
    public DistributedCopy(items, n) {
        var elements = [items[0]];
        var totalItems = items.length - 2;
        var interval = Math.floor(totalItems / (n - 2));
        for (var i = 1; i < n - 1; i++)
            elements.push(items[i * interval]);
        elements.push(items[items.length - 1]);
        return elements;
    }



    /**
     * Method is used to download file.
     * @param data - Array Buffer data
     * @param type - type of the document.
     * 
     * @example this.UtilitiesService.DownLoadFile(response, 'application/ms-excel');
     */
    public DownloadFile(data: any, type: string) {
        let blob = new Blob([data], { type: type });
        let url = window.URL.createObjectURL(blob);
        let pwa = window.open(url);
        if (!pwa || pwa.closed || typeof pwa.closed == 'undefined')
            alert('Please disable your Pop-up blocker and try again.');
    }



    // public FormatForMultiSelect(data, IDLabel, NameLabel, ParentID?) {
    //     let DataFormatted: IMultiSelectOption[] = [];

    //     for (let i = 0; i < data.length; i++) {

    //         let ID = Number.isInteger(data[i][IDLabel]) ? parseInt(data[i][IDLabel]) : data[i][IDLabel];
    //         ParentID = Number.isInteger(data[i][ParentID]) ? parseInt(data[i][ParentID]) : data[i][ParentID];

    //         DataFormatted.push(
    //             {
    //                 id: ID,
    //                 name: data[i][NameLabel],
    //                 parentId: ParentID,
    //             }
    //         );

    //     }

    //     return DataFormatted;
    // }



    public IsEmptyObject(object) {
        for (var key in object) {
            if (object.hasOwnProperty(key))
                return false;
        }
        return true;
    }



    /**
     * Simple object check.
     * @param item
     * @returns {boolean}
     */
    public IsObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }



    public NumberInWords(num): string {
        num = num.toString();

        const a = [
            '',
            'one ',
            'two ',
            'three ',
            'four ',
            'five ',
            'six ',
            'seven ',
            'eight ',
            'nine ',
            'ten ',
            'eleven ',
            'twelve ',
            'thirteen ',
            'fourteen ',
            'fifteen ',
            'sixteen ',
            'seventeen ',
            'eighteen ',
            'nineteen ',
        ];
        const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

        if ((num = num.toString()).length > 9) {
            return 'overflow';
        }
        const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) {
            return '';
        }
        let str = '';
        // str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
        // str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
        // str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
        // str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
        // str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
        str += n[5] !== '0' ? (str !== '' ? 'and ' : '') + (a[n[5]] || b[n[5][0]] + ' ' + a[n[5][1]]) + ' ' : '';
        return str;
    }



    public parse_url(query?) {
        if (!query && window && window.location && window.location.search) query = window.location.search.substring(1); // substring to remove the ? from the .search property

        var url = {
            query_string: location.search,
            query_string_object: {},
            url: location.pathname, // If no query string, this will be the only item in the object that's returned
        };

        if (!query)
            // If there's still nothing to parse
            return url;

        var vars = query.split('&');

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            var key = decodeURIComponent(pair[0]);
            var value = decodeURIComponent(pair[1]);
            // If first entry with this name
            if (typeof url.query_string_object[key] === 'undefined') {
                url.query_string_object[key] = decodeURIComponent(value);
                // If second entry with this name
            } else if (typeof url.query_string_object[key] === 'string') {
                var arr = [url.query_string_object[key], decodeURIComponent(value)];
                url.query_string_object[key] = arr;
                // If third or later entry with this name
            } else {
                url.query_string_object[key].push(decodeURIComponent(value));
            }
        }

        return url;
    }



    public PDF = {
        /* ======================================================
        USAGE:
            const PDFElement = document.querySelector('.net-worth-pdf-report');
            const PDFStyles = this.UtilitiesService.PDF.ExtractCSS(PDFElement);
            this.UtilitiesService.PDF.Generate('Some name', PDFElement, PDFStyles.stylesheet);
        
        https://stackoverflow.com/questions/53613045/how-get-all-computed-css-properties-of-element-and-its-children-in-javascript
        
        FROM ARTICLE
        
        Here is something I came up with, basically pass the element you want to extract the styles of and ones of its children, and it will return you the stylesheet as a string. Open your console before running the snippet and you will see the output from the console.log.

        Because I wanted to support the extraction of every element even those without a selector, I had to replace each element id by a unique uuid specifically generated for them in order to facilitate the styling of your output. The problem with this approach is in case you are using ids for styling or for user interaction, you are going to loose such functionality on concerned elements after calling extractCSS.
        
        However, it is pretty trivial to use the oldId I'm passing to change back once your pdfKit process finished the generation. Simply call swapBackIds passing the elements returned by the function. You can see the difference of behavior if you uncomment the call in my snippet: the #root pink background would disappear because the styling targets an element id.
        
        All in all, you need to:
        
        Call extractCSS with the element you want to extract
        Generate your pdf using res.stylesheet
        Call swapBackIds with res.elements
        ====================================================== */

        // AddFSILogo: (PDF, InsertFSILogoBefore) => {
        // WORKS - but use the PDF.addImage (below)
        //     var FSILogo = document.createElement('img');
        //     FSILogo.setAttribute('src', 'data:image/png;base64,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');
        //     FSILogo.setAttribute('width', '300px');

        //     return InsertFSILogoBefore.parentNode.insertBefore(FSILogo, InsertFSILogoBefore);
        // },

        ExtractCSS: (element) => {
            if (!element) return { elements: [], stylesheet: '' }

            var raw = this.PDF.RecursiveExtract(element);
            var flat = this.PDF.Flatten(raw);

            this.PDF.SwapBackIDs(flat); // Automatically call

            return {
                elements: flat,
                stylesheet: flat.reduce(function (acc, cur) {
                    var style = '#' + cur.id + ' {\n' + cur.style + '\n}\n\n'
                    return acc + style
                }, ''),
            };
        },

        Flatten: (arr) => {
            // Flatten an array
            // https://stackoverflow.com/a/15030117/2054072
            return arr.reduce((flat, toFlatten) => {
                return flat.concat(Array.isArray(toFlatten) ? this.PDF.Flatten(toFlatten) : toFlatten);
            }, []);
        },

        Generate: (Data) => {
            /* ======================================================
            USAGE
            
            this.UtilitiesService.PDF.Generate({
                // AddPageNumbers: true,
                // Download: false,
                InsertFSILogoBefore: PDFElement.querySelector('.card-body'),
                // FileName: 'file.pdf',
                PDFElement: PDFElement,
            });
            ====================================================== */

            // this.PDF._Loaded.next(false);

            // const $uniqid = (new Date().getTime()).toString(16);

            // // if (Data.InsertFSILogoBefore)
            // //     this.PDF.AddFSILogo(Data.PDFElement, Data.InsertFSILogoBefore);
            // // console.log(Data.PDFElement);
            // let GeneratedPDF = html2pdf()
            //     .from(Data.PDFElement.innerHTML)
            //     .set({
            //         dpi: 300,
            //         // enableLinks: true,
            //         filename: Data.FileName || $uniqid,
            //         html2canvas: { scale: 2, letterRendering: true, },
            //         image: { type: 'png' },
            //         jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            //         margin: [20, 10, 25, 10], // top, left, bottom, right
            //         pagebreak: { mode: ['all'], before: Data.PageBreaksBefore },
            //     })
            //     .toPdf()
            //     .get('pdf')
            //     .then((PDF) => {

            //         var FSILogo = 'data:image/png;base64,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';
            //         console.log(PDF);
            //         if (Data.AddPageNumbers === undefined || Data.AddPageNumbers === true) {

            //             var totalPages = PDF.internal.getNumberOfPages();

            //             for (let i = 1; i <= totalPages; i++) {
            //                 PDF.setPage(i);
            //                 PDF.setFontSize(10);
            //                 PDF.setTextColor(150);
            //                 PDF.text('' + i + ' of ' + totalPages,
            //                     ((PDF.internal.pageSize.getWidth() / 2) - 5), // left // -10 for spacing of "# of #"
            //                     (PDF.internal.pageSize.getHeight() - 10) // bottom, When using mm // (PDF.internal.pageSize.getHeight() - 0.3) // When using inches, works well
            //                 );

            //                 if (Data.AddLogo)
            //                     PDF.addImage(FSILogo, 'png', 10, 5, 75, 15);

            //                 // PDF.text('text 2 I am on page' + i, 10, 10);
            //             }

            //         }

            //         if (!Data.Download)
            //             window.open(PDF.output('bloburl'), '_blank');

            //         if (Data.OnComplete)
            //             Data.OnComplete(Data.Input); // Not passing anything now, but I can do something PDF-specific here - like hiding elements before sending it, then showing them when the PDF is done (we know that when this is called)

            //         this.PDF._Loaded.next(true);
            //     })

            // if (Data.Download === true)
            //     GeneratedPDF.save()

        },

        // Generate: (APIURL, Name, HTML, Styles) => {
        //     // Take the styles generated from a previous call to this.UtilitiesService.PDF.ExtractCSS

        //     /* ======================================================
        //     This is how we can get the PDF to open in a new window
        //     but using POST, so we can send all the HTML to the back end
        //     ====================================================== */

        //     const data = { Name: Name, HTML: HTML.innerHTML, Styles: Styles };

        //     const tempForm = document.createElement('form');
        //     tempForm.target = '_blank';
        //     tempForm.method = 'POST';
        //     tempForm.action = APIURL; // this.ServerService.GetAPIURL + '/general/toPDF'; (Circular Dependency)

        //     Object.keys(data).forEach(function (param) {
        //         var tempInput = document.createElement('input');
        //         tempInput.type = 'hidden';
        //         tempInput.name = param;
        //         tempInput.setAttribute('value', data[param]);
        //         tempForm.appendChild(tempInput);
        //     });

        //     document.body.appendChild(tempForm);
        //     tempForm.submit();
        // },

        _Loaded: new BehaviorSubject<any>(true),

        Loaded$: (): Observable<any> => {
            return this.PDF._Loaded.asObservable();
        },

        SwapBackIDs: (elements) => {
            elements.forEach(function (e) {
                var element = document.getElementById(e.id)
                element.setAttribute('id', e.oldId)
            });
        },

        RecursiveExtract: (element) => {
            var id = this.PDF.UniqueID();
            var oldId = element.id;

            var computed = window.getComputedStyle(element);
            var style = computed.cssText;

            element.setAttribute('id', id);// Now that we get the style, we can swap the id

            var children = Array.prototype.slice.call(element.children);// The children are not a real array but a NodeList, we need to convert them so we can map over them easily
            return [{ id: id, style: style, oldId: oldId }].concat(children.map(this.PDF.RecursiveExtract));
        },

        UniqueID: () => {
            // Generate an unique id for your element
            // From https://stackoverflow.com/a/2117523/2054072
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },

        /* ======================================================
        Not related to the PDF from HTML (methods above)
        ====================================================== */
        // FromTemplate: () => {
        //     // call general PDFFromTemplate
        //     // this
        //     // window.open(PDFURL, '_blank');
        //     // Adding ServerService - circular dependency
        // },

    };



    // public IterateObject(obj) {
    //     const keys = Object.keys(obj)
    //     const values = keys.map(key => `${key}: ${Reflect.get(obj, key)}`)
    //     return values;
    // }



    public RemoveDuplicates(OriginalArray, FilterProperty) {
        let NewArray = [];
        let LookupObject = {};

        for (let i = 0; i < OriginalArray.length; i++)
            LookupObject[OriginalArray[i][FilterProperty]] = OriginalArray[i];

        for (let i in LookupObject)
            NewArray.push(LookupObject[i]);

        return NewArray;
    }



    public RemoveNulls(tempData) {
        for (let k in tempData)
            if (Array.isArray(tempData[k]))
                tempData[k] = tempData[k].filter(function (el) {
                    return el != null;
                });

        return tempData;
    }



    public smoothScrollToTop(element, offset?, speedOverride?) {
        if (!offset) offset = 0;

        var currentYPosition = function () {
            // Firefox, Chrome, Opera, Safari
            if (self.pageYOffset) return self.pageYOffset;
            // Internet Explorer 6 - standards mode
            if (document.documentElement && document.documentElement.scrollTop)
                return document.documentElement.scrollTop;
            // Internet Explorer 6, 7 and 8
            if (document.body.scrollTop) return document.body.scrollTop;
            return 0;
        };

        var elmYPosition = function (elm) {
            var y = elm.offsetTop;
            var node = elm;
            while (node.offsetParent && node.offsetParent != document.body) {
                node = node.offsetParent;
                y += node.offsetTop;
            } return y;
        };

        var scrollTo = function (yPoint: number, duration: number) {
            setTimeout(() => {
                window.scrollTo(0, yPoint)
            }, duration);
            return;
        };

        let startY = currentYPosition();
        // let stopY = scrollToY || 0;
        var stopY = elmYPosition(element) + offset;
        let distance = stopY > startY ? stopY - startY : startY - stopY;
        console.log(startY, stopY, distance);
        if (distance < 100) {
            window.scrollTo(0, stopY);
            return;
        }
        let speed = speedOverride || Math.round(distance / 100);
        let step = speed;
        speed = Math.max(9, speed); //min 9 otherwise it won't look smooth
        let leapY = stopY > startY ? startY + step : startY - step;
        let timer = 0;
        if (stopY > startY) {
            for (let i = startY; i < stopY; i += step) {
                // since setTimeout is asynchronous, the for-loop will will fire all scrolls
                // nearly simoultaniously. Therefore, we need to multiply the speed with
                // a counter which lets the scrolls start with a growing offset which lets the
                // setTimeout wait for a growing time till it scrolls there
                // that way, we prevent the window to scroll instantly to the target Yposition
                scrollTo(leapY, timer * speed);
                leapY += step; if (leapY > stopY) leapY = stopY; timer++;
            }
            return;
        } else {
            for (let i = startY; i > stopY; i -= step) {
                scrollTo(leapY, timer * speed);
                leapY -= step; if (leapY < stopY) leapY = stopY; timer++;
            }
        }
    }



}
